import { render, staticRenderFns } from "./sustainability.vue?vue&type=template&id=179f6af8&"
import script from "./sustainability.vue?vue&type=script&lang=js&"
export * from "./sustainability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports